import { AccessLoadTimeoutError } from '../error-kind'

export { AccessLoadTimeoutError }

/** The session check or the code exchange did not answer within the deadline. A retry may succeed, so it is transient. */
export class SessionLoadTimeoutError extends AccessLoadTimeoutError {
    constructor(timeoutMs: number) {
        super(timeoutMs)
        this.message = `The session load did not finish within ${timeoutMs} ms`
        this.name = 'SessionLoadTimeoutError'
    }
}

/**
 * How long boot waits for the whole access load (domains, abilities, flags, the open domain) before it
 * shows the failed screen with Retry. Without it, one call that never answers holds the loading screen
 * forever. The budget is sized for a slow network anywhere in the world, not for a fast one: a user who
 * waits this long and then sees Retry is better served than one whose slow but working boot is failed.
 */
export const ACCESS_LOAD_TIMEOUT_MS = 45_000

/**
 * Starts the deadline. `onTimeout` runs once if `cancel` has not been called by then; `cancel` is safe to
 * call any number of times.
 */
export const startAccessDeadline = (
    onTimeout: (error: AccessLoadTimeoutError) => void,
    tier: 'session' | 'access' = 'access',
): { cancel: () => void } => {
    const timer = setTimeout(
        () =>
            onTimeout(
                tier === 'session'
                    ? new SessionLoadTimeoutError(ACCESS_LOAD_TIMEOUT_MS)
                    : new AccessLoadTimeoutError(ACCESS_LOAD_TIMEOUT_MS),
            ),
        ACCESS_LOAD_TIMEOUT_MS,
    )

    return { cancel: () => clearTimeout(timer) }
}
